import { render, staticRenderFns } from "./HighSpeedRunningRadialChart.vue?vue&type=template&id=366f63b1"
import script from "./HighSpeedRunningRadialChart.vue?vue&type=script&lang=js"
export * from "./HighSpeedRunningRadialChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports